import { type OutgoingRelationshipProposal, relationshipKeys } from '@taler/api-client'
import { useQuery } from '@tanstack/vue-query'
import { computed, type ComputedRef } from 'vue'
import { useApi } from '@/app/api'
import { retrying } from '@/app/retrying'

export interface UseOutgoingProposals {
  readonly proposals: ComputedRef<readonly OutgoingRelationshipProposal[]>
  readonly isLoading: ComputedRef<boolean>
  readonly error: ComputedRef<Error | null>
  readonly retrying: ComputedRef<boolean>
  retry(): void
}

export function useOutgoingProposals(ledgerId: () => string | undefined): UseOutgoingProposals {
  const api = useApi()
  const query = useQuery({
    queryKey: computed(() => relationshipKeys.outgoing(ledgerId() ?? '')),
    queryFn: ({ signal }) => api.relationships.listOutgoingProposals(ledgerId() ?? '', signal),
    enabled: computed(() => ledgerId() !== undefined),
    retry: false,
  })

  return {
    proposals: computed(() => query.data.value ?? []),
    isLoading: computed(() => query.isPending.value),
    error: computed(() => query.error.value),
    retrying: retrying(query),
    retry: () => {
      void query.refetch()
    },
  }
}
